import { List } from 'antd';
import React from 'react';
import {
  StyledDrawer,
  StyledList,
  StyledListItem,
  StyledTitle,
} from './styled';

const HistoryDrawer = ({ open, setOpen }) => {
  const onClose = () => {
    setOpen(false);
  };

  // Exemple de données d'historique
  const historyData = [
    {
      title: 'Action 1',
      description: "Description de l'action 1",
      time: '10:00',
    },
    {
      title: 'Action 2',
      description: "Description de l'action 2",
      time: '09:30',
    },
  ];

  return (
    <StyledDrawer
      title={<StyledTitle level={4}>Historique</StyledTitle>}
      placement="right"
      closable={true}
      onClose={onClose}
      open={open}
      getContainer={false}
    >
      <StyledList
        dataSource={historyData}
        renderItem={(item) => (
          <StyledListItem>
            <List.Item.Meta title={item.title} description={item.description} />
            <div>{item.time}</div>
          </StyledListItem>
        )}
      />
    </StyledDrawer>
  );
};

export default HistoryDrawer;
